// 'use strict';

var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source,
          key)) { target[key] = source[key]; }
    }
  }
  return target;
};

var _createClass = function() {
  function defineProperties(
      target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function(
      Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _possibleConstructorReturn(
    self, call) {
  if (!self) {
    throw new ReferenceError(
        'this hasn\'t been initialised - super() hasn\'t been called');
  }
  return call && (typeof call === 'object' || typeof call === 'function')
      ? call
      : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' +
                        typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true,
    },
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass,
      superClass) : subClass.__proto__ = superClass;
}

var React = require('react');
var PropTypes = require('prop-types');

var _require = require('react-dom'),
    findDOMNode = _require.findDOMNode;

var scrollIntoView = require('dom-scroll-into-view');

var IMPERATIVE_API = [
  'blur',
  'checkValidity',
  'click',
  'focus',
  'select',
  'setCustomValidity',
  'setSelectionRange',
  'setRangeText'];

function getScrollOffset() {
  return {
    x: window.pageXOffset !== undefined
        ? window.pageXOffset
        : (document.documentElement || document.body.parentNode ||
           document.body).scrollLeft,
    y: window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode ||
           document.body).scrollTop,
  };
}

var Autocomplete2 = function(_React$Component) {
  _inherits(Autocomplete2, _React$Component);

  function Autocomplete2(props) {
    _classCallCheck(this, Autocomplete2);

    var _this = _possibleConstructorReturn(this,
        (Autocomplete2.__proto__ || Object.getPrototypeOf(Autocomplete2)).call(
            this, props));

    _this.state = {
      isOpen: false,
      highlightedIndex: null,
    };
    _this._debugStates = [];
    _this.ensureHighlightedIndex = _this.ensureHighlightedIndex.bind(_this);
    _this.exposeAPI = _this.exposeAPI.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.maybeAutoCompleteText = _this.maybeAutoCompleteText.bind(_this);
    return _this;
  }

  _createClass(Autocomplete2, [
    {
      key: 'componentWillMount',
      value: function componentWillMount() {
        // this.refs is frozen, so we need to assign a new object to it
        this.refs = {};
        this._ignoreBlur = false;
        this._ignoreFocus = false;
        this._scrollOffset = null;
        this._scrollTimer = null;
      },
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearTimeout(this._scrollTimer);
        this._scrollTimer = null;
      },
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.state.highlightedIndex !== null) {
          this.setState(this.ensureHighlightedIndex);
        }
        if (nextProps.autoHighlight && (this.props.value !== nextProps.value ||
                                        this.state.highlightedIndex === null)) {
          this.setState(this.maybeAutoCompleteText);
        }
      },
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.isOpen()) {
          this.setMenuPositions();
        }
      },
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if ((this.state.isOpen && !prevState.isOpen) || ('open' in this.props && this.props.open && !prevProps.open)) 
            this.setMenuPositions();

        this.maybeScrollItemIntoView();
        if (prevState.isOpen !== this.state.isOpen) {
          this.props.onMenuVisibilityChange(this.state.isOpen);
        }
      },
    }, {
      key: 'exposeAPI',
      value: function exposeAPI(el) {
        var _this2 = this;

        this.refs.input = el;
        IMPERATIVE_API.forEach(function(ev) {
          return _this2[ev] = el && el[ev] && el[ev].bind(el);
        });
      },
    }, {
      key: 'maybeScrollItemIntoView',
      value: function maybeScrollItemIntoView() {
        if (this.isOpen() && this.state.highlightedIndex !== null) {
          var itemNode = this.refs['item-' + this.state.highlightedIndex];
          var menuNode = this.refs.menu;
          scrollIntoView(findDOMNode(itemNode), findDOMNode(menuNode),
              {onlyScrollIfNeeded: true});
        }
      },
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(event) {
        if (Autocomplete2.keyDownHandlers[event.key]) Autocomplete2.keyDownHandlers[event.key].call(
            this, event); else if (!this.isOpen()) {
          this.setState({
            isOpen: true,
          });
        }
      },
    }, {
      key: 'handleChange',
      value: function handleChange(event) {
        this.props.onChange(event, event.target.value);
      },
    }, {
      key: 'getFilteredItems',
      value: function getFilteredItems(props) {
        var items = props.items;

        if (props.shouldItemRender) {
          items = items.filter(function(item) {
            return props.shouldItemRender(item, props.value);
          });
        }

        if (props.sortItems) {
          items.sort(function(a, b) {
            return props.sortItems(a, b, props.value);
          });
        }

        return items;
      },
    }, {
      key: 'maybeAutoCompleteText',
      value: function maybeAutoCompleteText(state, props) {
        var highlightedIndex = state.highlightedIndex;
        var value = props.value,
            getItemValue = props.getItemValue;

        var index = highlightedIndex === null ? 0 : highlightedIndex;
        var items = this.getFilteredItems(props);
        for (var i = 0; i < items.length; i++) {
          if (props.isItemSelectable(items[index])) break;
          index = (index + 1) % items.length;
        }
        var matchedItem = items[index] && props.isItemSelectable(items[index])
            ? items[index]
            : null;
        if (value !== '' && matchedItem) {
          var itemValue = getItemValue(matchedItem);
          var itemValueDoesMatch = itemValue.toString().toLowerCase().indexOf(value.toString().toLowerCase()) === 0;
          if (itemValueDoesMatch) {
            return {highlightedIndex: index};
          }
        }
        return {highlightedIndex: null};
      },
    }, {
      key: 'ensureHighlightedIndex',
      value: function ensureHighlightedIndex(state, props) {
        if (state.highlightedIndex >= this.getFilteredItems(props).length) {
          return {highlightedIndex: null};
        }
      },
    }, {
      key: 'setMenuPositions',
      value: function setMenuPositions() {
        var node = this.refs.input;
        var rect = node.getBoundingClientRect();
        var computedStyle = global.window.getComputedStyle(node);
        var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
        var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
        var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
        this.setState({
          menuTop: rect.bottom + marginBottom,
          menuLeft: rect.left + marginLeft,
          menuWidth: rect.width + marginLeft + marginRight,
        });
      },
    }, {
      key: 'highlightItemFromMouse',
      value: function highlightItemFromMouse(index) {
        this.setState({highlightedIndex: index});
      },
    }, {
      key: 'selectItemFromMouse',
      value: function selectItemFromMouse(item) {
        var _this3 = this;

        var value = this.props.getItemValue(item);
        // The menu will de-render before a mouseLeave event
        // happens. Clear the flag to release control over focus
        this.setIgnoreBlur(false);
        this.setState({
          isOpen: false,
          highlightedIndex: null,
        }, function() {
          _this3.props.onSelect(value, item);
        });
      },
    }, {
      key: 'setIgnoreBlur',
      value: function setIgnoreBlur(ignore) {
        this._ignoreBlur = ignore;
      },
    }, {
      key: 'renderMenu',
      value: function renderMenu() {
        var _this4 = this;

        var items = this.getFilteredItems(this.props).map(function(item, index) {
              var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index,{cursor: 'default'});
              return React.cloneElement(element, {
                onMouseEnter: _this4.props.isItemSelectable(item) ? function() {
                  return _this4.highlightItemFromMouse(index);
                } : null,
                onClick: _this4.props.isItemSelectable(item) ? function() {
                  return _this4.selectItemFromMouse(item);
                } : null,
                ref: function ref(e) {
                  return _this4.refs['item-' + index] = e;
                },
              });
            });
        var style = {
          left: this.state.menuLeft,
          top: this.state.menuTop,
          minWidth: this.state.menuWidth,
        };
        var menu = this.props.renderMenu(items, this.props.value, style);
        return React.cloneElement(menu, {
          ref: function ref(e) {
            return _this4.refs.menu = e;
          },
          // Ignore blur to prevent menu from de-rendering before we can process click
          onMouseEnter: function onMouseEnter() {
            return _this4.setIgnoreBlur(true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this4.setIgnoreBlur(false);
          },
        });
      },
    }, {
      key: 'handleInputBlur',
      value: function handleInputBlur(event) {
        var _this5 = this;

        if (this._ignoreBlur) {
          this._ignoreFocus = true;
          this._scrollOffset = getScrollOffset();
          this.refs.input.focus();
          return;
        }
        var setStateCallback = void 0;
        var highlightedIndex = this.state.highlightedIndex;

        if (this.props.selectOnBlur && highlightedIndex !== null) {
          var items = this.getFilteredItems(this.props);
          var item = items[highlightedIndex];
          var value = this.props.getItemValue(item);
          setStateCallback = function setStateCallback() {
            return _this5.props.onSelect(value, item);
          };
        }
        this.setState({
          isOpen: false,
          highlightedIndex: null,
        }, setStateCallback);
        var onBlur = this.props.inputProps.onBlur;

        if (onBlur) {
          onBlur(event);
        }
      },
    }, {
      key: 'handleInputFocus',
      value: function handleInputFocus(event) {
        var _this6 = this;

        if (this._ignoreFocus) {
          this._ignoreFocus = false;
          var _scrollOffset = this._scrollOffset,
              x = _scrollOffset.x,
              y = _scrollOffset.y;

          this._scrollOffset = null;
          // Focus will cause the browser to scroll the <input> into view.
          // This can cause the mouse coords to change, which in turn
          // could cause a new highlight to happen, cancelling the click
          // event (when selecting with the mouse)
          window.scrollTo(x, y);
          // Some browsers wait until all focus event handlers have been
          // processed before scrolling the <input> into view, so let's
          // scroll again on the next tick to ensure we're back to where
          // the user was before focus was lost. We could do the deferred
          // scroll only, but that causes a jarring split second jump in
          // some browsers that scroll before the focus event handlers
          // are triggered.
          clearTimeout(this._scrollTimer);
          this._scrollTimer = setTimeout(function() {
            _this6._scrollTimer = null;
            window.scrollTo(x, y);
          }, 0);
          return;
        }
        this.setState({isOpen: true});
        var onFocus = this.props.inputProps.onFocus;

        if (onFocus) {
          onFocus(event);
        }
      },
    }, {
      key: 'isInputFocused',
      value: function isInputFocused() {
        var el = this.refs.input;
        return el.ownerDocument && el === el.ownerDocument.activeElement;
      },
    }, {
      key: 'handleInputClick',
      value: function handleInputClick() {
        // Input will not be focused if it's disabled
        if (this.isInputFocused() && !this.isOpen()) this.setState(
            {isOpen: true});
      },
    }, {
      key: 'composeEventHandlers',
      value: function composeEventHandlers(internal, external) {
        return external ? function(e) {
          internal(e);
          external(e);
        } : internal;
      },
    }, {
      key: 'isOpen',
      value: function isOpen() {
        return 'open' in this.props ? this.props.open : this.state.isOpen;
      },
    }, {
      key: 'render',
      value: function render() {
        if (this.props.debug) {
          // you don't like it, you love it
          this._debugStates.push({
            id: this._debugStates.length,
            state: this.state,
          });
        }

        var inputProps = this.props.inputProps;

        var open = this.isOpen();
        return React.createElement(
            'div',
            _extends({style: _extends({}, this.props.wrapperStyle)},
                this.props.wrapperProps),
            this.props.renderInput(_extends({}, inputProps, {
              role: 'combobox',
              'aria-autocomplete': 'list',
              'aria-expanded': open,
              autoComplete: 'off',
              ref: this.exposeAPI,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onChange: this.handleChange,
              onKeyDown: this.composeEventHandlers(this.handleKeyDown,
                  inputProps.onKeyDown),
              onClick: this.composeEventHandlers(this.handleInputClick,
                  inputProps.onClick),
              value: this.props.value,
            })),
            open && this.renderMenu(),
            this.props.debug && React.createElement(
            'pre',
            {style: {marginLeft: 300}},
            JSON.stringify(this._debugStates.slice(
                Math.max(0, this._debugStates.length - 5),
                this._debugStates.length), null, 2),
                             ),
        );
      },
    }]);

  return Autocomplete2;
}(React.Component);

Autocomplete2.propTypes = {
  /**
   * The items to display in the dropdown menu
   */
  items: PropTypes.array.isRequired,
  /**
   * The value to display in the input field
   */
  value: PropTypes.any,
  /**
   * Arguments: `event: Event, value: String`
   *
   * Invoked every time the user changes the input's value.
   */
  onChange: PropTypes.func,
  /**
   * Arguments: `value: String, item: Any`
   *
   * Invoked when the user selects an item from the dropdown menu.
   */
  onSelect: PropTypes.func,
  /**
   * Arguments: `item: Any, value: String`
   *
   * Invoked for each entry in `items` and its return value is used to
   * determine whether or not it should be displayed in the dropdown menu.
   * By default all items are always rendered.
   */
  shouldItemRender: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Invoked when attempting to select an item. The return value is used to
   * determine whether the item should be selectable or not.
   * By default all items are selectable.
   */
  isItemSelectable: PropTypes.func,
  /**
   * Arguments: `itemA: Any, itemB: Any, value: String`
   *
   * The function which is used to sort `items` before display.
   */
  sortItems: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Used to read the display value from each entry in `items`.
   */
  getItemValue: PropTypes.func.isRequired,
  /**
   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
   *
   * Invoked for each entry in `items` that also passes `shouldItemRender` to
   * generate the render tree for each item in the dropdown menu. `styles` is
   * an optional set of styles that can be applied to improve the look/feel
   * of the items in the dropdown menu.
   */
  renderItem: PropTypes.func.isRequired,
  /**
   * Arguments: `items: Array<Any>, value: String, styles: Object`
   *
   * Invoked to generate the render tree for the dropdown menu. Ensure the
   * returned tree includes every entry in `items` or else the highlight order
   * and keyboard navigation logic will break. `styles` will contain
   * { top, left, minWidth } which are the coordinates of the top-left corner
   * and the width of the dropdown menu.
   */
  renderMenu: PropTypes.func,
  /**
   * Styles that are applied to the dropdown menu in the default `renderMenu`
   * implementation. If you override `renderMenu` and you want to use
   * `menuStyle` you must manually apply them (`this.props.menuStyle`).
   */
  menuStyle: PropTypes.object,
  /**
   * Arguments: `props: Object`
   *
   * Invoked to generate the input element. The `props` argument is the result
   * of merging `props.inputProps` with a selection of props that are required
   * both for functionality and accessibility. At the very least you need to
   * apply `props.ref` and all `props.on<event>` event handlers. Failing to do
   * this will cause `Autocomplete2` to behave unexpectedly.
   */
  renderInput: PropTypes.func,
  /**
   * Props passed to `props.renderInput`. By default these props will be
   * applied to the `<input />` element rendered by `Autocomplete2`, unless you
   * have specified a custom value for `props.renderInput`. Any properties
   * supported by `HTMLInputElement` can be specified, apart from the
   * following which are set by `Autocomplete2`: value, autoComplete, role,
   * aria-autocomplete. `inputProps` is commonly used for (but not limited to)
   * placeholder, event handlers (onFocus, onBlur, etc.), autoFocus, etc..
   */
  inputProps: PropTypes.object,
  /**
   * Props that are applied to the element which wraps the `<input />` and
   * dropdown menu elements rendered by `Autocomplete2`.
   */
  wrapperProps: PropTypes.object,
  /**
   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
   * will win if it contains a `style` entry.
   */
  wrapperStyle: PropTypes.object,
  /**
   * Whether or not to automatically highlight the top match in the dropdown
   * menu.
   */
  autoHighlight: PropTypes.bool,
  /**
   * Whether or not to automatically select the highlighted item when the
   * `<input>` loses focus.
   */
  selectOnBlur: PropTypes.bool,
  /**
   * Arguments: `isOpen: Boolean`
   *
   * Invoked every time the dropdown menu's visibility changes (i.e. every
   * time it is displayed/hidden).
   */
  onMenuVisibilityChange: PropTypes.func,
  /**
   * Used to override the internal logic which displays/hides the dropdown
   * menu. This is useful if you want to force a certain state based on your
   * UX/business logic. Use it together with `onMenuVisibilityChange` for
   * fine-grained control over the dropdown menu dynamics.
   */
  open: PropTypes.bool,
  debug: PropTypes.bool,
};
Autocomplete2.defaultProps = {
  value: '',
  wrapperProps: {},
  wrapperStyle: {
    display: 'inline-block',
  },
  inputProps: {},
  renderInput: function renderInput(props) {
    return React.createElement('input', props);
  },
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  isItemSelectable: function isItemSelectable() {
    return true;
  },
  renderMenu: function renderMenu(items, value, style) {
    return React.createElement('div',
        {style: _extends({}, style, this.menuStyle), children: items});
  },

  menuStyle: {
    borderRadius: '3px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    background: 'rgba(255, 255, 255, 0.9)',
    padding: '2px 0',
    fontSize: '90%',
    position: 'fixed',
    overflow: 'auto',
    maxHeight: '50%',
  },
  autoHighlight: true,
  selectOnBlur: false,
  onMenuVisibilityChange: function onMenuVisibilityChange() {},
};
Autocomplete2.keyDownHandlers = {
  ArrowDown: function ArrowDown(event) {
    event.preventDefault();
    var items = this.getFilteredItems(this.props);
    if (!items.length) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null ? -1 : highlightedIndex;
    for (var i = 0; i < items.length; i++) {
      var p = (index + i + 1) % items.length;
      if (this.props.isItemSelectable(items[p])) {
        index = p;
        break;
      }
    }
    if (index > -1 && index !== highlightedIndex) {
      this.setState({
        highlightedIndex: index,
        isOpen: true,
      });
    }
  },
  ArrowUp: function ArrowUp(event) {
    event.preventDefault();
    var items = this.getFilteredItems(this.props);
    if (!items.length) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null ? items.length : highlightedIndex;
    for (var i = 0; i < items.length; i++) {
      var p = (index - 1 + items.length) % items.length;
      if (this.props.isItemSelectable(items[p])) {
        index = p;
        break;
      }
    }
    if (index !== items.length) {
      this.setState({
        highlightedIndex: index,
        isOpen: true,
      });
    }
  },
  Enter: function Enter(event) {
    var _this7 = this;

    // Key code 229 is used for selecting items from character selectors (Pinyin, Kana, etc)
    if (event.keyCode !== 13) return;
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    if (!this.isOpen()) {
      // menu is closed so there is no selection to accept -> do nothing
      return;
    } else if (this.state.highlightedIndex == null) {
      // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
      this.setState({
        isOpen: false,
      }, function() {
        _this7.refs.input.select();
      });
    } else {
      // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
      event.preventDefault();
      var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
      var value = this.props.getItemValue(item);
      this.setState({
        isOpen: false,
        highlightedIndex: null,
      }, function() {
        //this.refs.input.focus() // TODO: file issue
        _this7.refs.input.setSelectionRange(value.length, value.length);
        _this7.props.onSelect(value, item);
      });
    }
  },
  Escape: function Escape() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    this.setState({
      highlightedIndex: null,
      isOpen: false,
    });
  },
  Tab: function Tab() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
  },
};

module.exports = Autocomplete2;


// WEBPACK FOOTER //
// ./src/component/element/AutoComplete2.js